import { TransportModeHelper } from '../../../../helpers/transport-mode.helper';
import { TransportSubModeHelper } from '../../../../helpers/transport-sub-mode.helper';
import type { ILine } from '../../../../models/line.model';

export class LineApiModel {
  public static mapToBusinessModel(apiModel: LineApiModel): ILine {
    return {
      name: apiModel.name || '',
      backgroundColor: apiModel.backgroundColor,
      foregroundColor: apiModel.foregroundColor,
      borderColor: apiModel.borderColor,
      transportMode: TransportModeHelper.parse(apiModel.transportMode),
      transportSubMode: TransportSubModeHelper.parse(apiModel.transportSubMode),
      designation: apiModel.designation,
      isWheelchairAccessible: apiModel.isWheelchairAccessible,
      gid: undefined,
      technicalLineNumber: undefined,
      shortName: apiModel.shortName || '',
      directionName: undefined,
      contractorId: undefined,
      isPublicTransport: undefined,
      municipalities: undefined,
      appliesFrom: undefined,
      appliesUpto: undefined,
      transportAuthorityGid: undefined,
    };
  }

  public name?: string;
  public backgroundColor?: string;
  public foregroundColor?: string;
  public borderColor?: string;
  public transportMode!: string;
  public transportSubMode!: string;
  public designation?: string;
  public isWheelchairAccessible!: boolean;
  public shortName?: string;
  public isRealtimeJourney?: boolean;
}
